import { urlPrefix, urlToken } from '~/config/i18n.pages'

export default {
  props: {
    label: {
      type: String,
    },
    placeholder: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      textInput: '',
    }
  },

  computed: {
    hasLabel() {
      const hasLabel = this.label

      if (hasLabel) return true
    },
  },

  methods: {
    search() {
      this.$router.push(
        `/${this.$i18n.locale}/${urlPrefix[this.$i18n.locale]}/${
          urlToken.positions[this.$i18n.locale]
        }?search=${this.textInput}`
      )
      this.$router.push({
        name: `positions___${this.$i18n.locale}`,
        query: { search: this.textInput },
      })
    },
  },
}
